/*
 * Copyright (c) 2020 - 2025 Ping Identity Corporation. All rights reserved.
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file for details.
 */
import { StepType } from '@forgerock/sdk-types';
import { Policy } from './policy/policy.js';
function getCode(payload) {
    return Number(payload.code);
}
function getDetail(payload) {
    return payload.detail;
}
function getMessage(payload) {
    return payload.message;
}
function getProcessedMessage(payload, messageCreator) {
    return Policy.parseErrors(payload, messageCreator);
}
function getReason(payload) {
    return payload.reason;
}
function createJourneyLoginFailure(payload) {
    return {
        payload,
        type: StepType.LoginFailure,
        getCode: () => getCode(payload),
        getDetail: () => getDetail(payload),
        getMessage: () => getMessage(payload),
        getProcessedMessage: (messageCreator) => getProcessedMessage(payload, messageCreator),
        getReason: () => getReason(payload),
    };
}
export { createJourneyLoginFailure };
